import Turbolinks from 'turbolinks';
import { Navigation } from '../Shared/navigation';
import { Amplitude } from '../Shared/amplitude';

export const initDocumentList = () => {
	$('.document-list__document-link').click((e) => {
		const isDeal = !!$('#deal-key').val();
		const eventName = isDeal ? 'Deal - Data Room - Open document' : 'Project - Data Room - Open document';
		Amplitude.logEvent(eventName, {
			'Project': $('#project-name').val(),
			'Document': (e.target.innerText as string).trim()
		});
	});

	initAttachLinkModal();
	initDeleteLinkForm();
}

const initAttachLinkModal = () => {
	let $modal = $('#attach-link-modal');

	var initForm = function () {
		let $form = $modal.find('#attach-link-form');

		let $url = $form.find('#attach-link-url');
		let $title = $form.find('#attach-link-title');
		let $saveBtn = $modal.find('button[form="attach-link-form"]');

		$url.val('');
		$title.val('');
		$title.attr('disabled', 'disabled');
		$saveBtn.attr('disabled', 'disabled');

		$url.on("change paste keyup", function () {
			let url = $(this).val();

			const enableSave = () => {
				$title.removeAttr('disabled');
				$saveBtn.removeAttr('disabled');
				$modal.find('.loading-ico').addClass('d-none');
			}

			if (url) {
				$modal.find('.loading-ico').removeClass('d-none');

				$.ajax({
					data: { url: url },
					type: 'GET',
					url: '/config/project/fetchlink',
					success: function (response) {
						$title.val(response.title);
						enableSave();
					},
					error: function () {
						enableSave();
					}
				});
			}
		});

		$form.on('submit', function (e) {
			e.preventDefault();

			if ($form.validate().form()) {
				$.ajax({
					data: $form.serialize(),
					type: $form.attr('method'),
					url: $form.attr('action'),
					contentType: 'application/x-www-form-urlencoded',
					success: function () {
						$modal.hide();
						Navigation.reload();
					},
					error: function (response) {
						if (response.responseText) {
							$modal.find('.modal-body').empty().html(response.responseText);
							initForm();
						}
					}
				});
			}
		});
	}

	$modal.on('show.bs.modal', function (e) {
		initForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('#attach-link-form').off('submit');
	});

	$('#attach-link-btn').click(function (e) {
		e.preventDefault();
		$modal.modal('show');
	});
}

const initDeleteLinkForm = () => {
	$('.delete-link-form').on('submit', function (e) {
		e.preventDefault();
		let $this = $(this);

		$.ajax({
			data: $this.serialize(),
			type: $this.attr('method'),
			url: $this.attr('action'),
			contentType: 'application/x-www-form-urlencoded',
			success: function () {
				Navigation.reload();
			}
		});
	});
}